import React from 'react'
import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'

export const history = createBrowserHistory()

export const RouterProvider: React.FC = ({ children }) => {
  return <Router history={history}>{children}</Router>
}
